import type { CampaignSchema } from "@/types";

/**
 * Whether the player can still opt into a campaign: it takes opt-ins at all (`opt_in_method`
 * other than "NONE"), they have not joined, and it has not finished. The ONE rule every type's
 * detail view uses for its Opt In — tournaments used to skip the method check, so a no-opt-in
 * tournament still offered a button that did nothing useful.
 */
export const canJoinCampaign = (
  campaign: Pick<CampaignSchema, "opt_in_method" | "status">,
  joined: boolean
): boolean =>
  campaign.opt_in_method !== "NONE" && !joined && campaign.status !== "FI";

/**
 * Whether the opt-in PROMPT may ask about this campaign: joinable, and opted into in the widget
 * itself ("OVERLAY"). Campaigns the operator opts players into through their own API keep the
 * plain Opt In button only — a bold widget prompt could contradict the operator's own flow
 * (opt-in by deposit, by a landing page).
 */
export const promptsForOptIn = (
  campaign: Pick<CampaignSchema, "opt_in_method" | "status">,
  joined: boolean
): boolean =>
  canJoinCampaign(campaign, joined) && campaign.opt_in_method === "OVERLAY";
